import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  }
};
export function PrivacyPolicyPage() {
  const {
    t
  } = useLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const sections = t.privacy.sections;
  return <div className="pt-20" data-id="element-496">
      {/* Hero */}
      <section className="relative bg-brand-dark py-20 overflow-hidden" data-id="element-497">
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/95 to-brand-dark/80" data-id="element-498" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-499">
          <Link to="/" className="inline-flex items-center gap-2 text-brand-gold hover:text-white transition-colors mb-8 font-semibold" data-id="element-500">
            <ArrowLeft size={20} data-id="element-501" />
            {t.free.back}
          </Link>
          <motion.div {...fadeIn} data-id="element-502">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-red/10 border border-brand-red/20 mb-6" data-id="element-503">
              <ShieldCheck className="text-brand-gold" size={20} data-id="element-504" />
              <span className="text-brand-gold font-semibold text-sm uppercase tracking-wider" data-id="element-505">
                {t.privacy.badge}
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-506">
              {t.privacy.title}
            </h1>
            <p className="text-gray-400" data-id="element-507">{t.privacy.lastUpdated}</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white" data-id="element-508">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-509">
          <motion.p {...fadeIn} className="text-lg text-gray-600 mb-12 leading-relaxed" data-id="element-510">
            {t.privacy.intro}
          </motion.p>

          <div className="space-y-12" data-id="element-511">
            {sections.map((section: {
            heading: string;
            content: string;
          }, index: number) => <motion.div key={index} {...fadeIn} transition={{
            delay: index * 0.05
          }} data-id="element-512">
                  <h2 className="text-2xl font-bold text-brand-dark mb-4 flex items-start gap-3" data-id="element-513">
                    <span className="text-brand-red font-black" data-id="element-514">
                      {index + 1}.
                    </span>
                    {section.heading}
                  </h2>
                  <p className="text-gray-600 leading-relaxed text-lg" data-id="element-515">
                    {section.content}
                  </p>
                </motion.div>)}
          </div>

          <motion.div {...fadeIn} className="mt-16 p-8 bg-brand-gray rounded-sm" data-id="element-516">
            <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-517">
              {t.privacy.contactTitle}
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-518">
              {t.privacy.contactText}
            </p>
            <p className="text-gray-800 font-semibold mt-4" data-id="element-519">
              elitepropertyadjusters@gmail.com
              <br data-id="element-520" />
              (305) 417-0530 | (305) 785-7829
              <br data-id="element-521" />
              1758 NE 177th St., North Miami Beach, FL 33162
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
}